export default function test(state = {}, action) {
    switch (action.type) {
        case "clear_cache_success":
            return { ...state, status: 'clear_cache_success' };
        case "clear_cache_failed":
            return { ...state, status: 'clear_cache_failed' };
        default:
            return state;
    }
}